import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { Button, Input, Space, Table, Typography, Select } from "antd";
import { LeftOutlined, BulbOutlined, PlusOutlined } from "@ant-design/icons";

const { Search } = Input;

const Users = () => {
  const [pageSize, setPageSize] = useState(10);
  const navigate = useNavigate();
  const columns = [
    { title: "User", dataIndex: "User", key: "User" },
    { title: "Role", dataIndex: "Role", key: "Role" },
    { title: "Email", dataIndex: "Email", key: "Email" },
    { title: "Last Login", dataIndex: "Last Login", key: "Last Login" },
    {
      title: "Reporting Hierarchy",
      dataIndex: "Reporting Hierarchy",
      key: "Reporting Hierarchy",
    },
    {
      title: "Mobile Restrict",
      dataIndex: "Mobile Restrict",
      key: "Mobile Restrict",
    },
    {
      title: "Work Processor",
      dataIndex: "Work Processor",
      key: "Work Processor",
    },
    { title: "Status", dataIndex: "Status", key: "Status" },
  ];

  const data = [
    {
      key: 1,
      User: "Muhammad Siraj",
      Role: "Self Service",
      Email: "msiraj1042@gmail.com",
      "Last Login": "07/03/2025 09:35:56 PM",
      "Reporting Hierarchy": "All Level",
      "Mobile Restrict": "No",
      "Work Processor": "No",
      Status: "Activated",
    },
  ];

  return (
    <div className="p-4 bg-white rounded-lg shadow flex flex-col gap-5">
      <div className="flex justify-between items-center">
        <h4 className="!mb-0 font-semibold">Manage Users</h4>
        <Space>
          <div className="flex items-center gap-1">
            <Button type="default" className="!rounded-full !text-active-color">
              Upload
            </Button>
          </div>
          <Button
            icon={<LeftOutlined />}
            type="default"
            onClick={() => navigate(-1)}
            className="!border-active-color !text-active-color"
          >
            Back
          </Button>
          <Button
            icon={<BulbOutlined />}
            className="!border-active-color !text-active-color"
          >
            Page Tip
          </Button>
        </Space>
      </div>
      <div className="flex items-center justify-between">
        <div className="flex items-center gap-4">
          <Typography.Text className="whitespace-nowrap">
            Showing 1 - {data.length}
          </Typography.Text>
          <Search placeholder="Search" allowClear className="w-full max-w-sm" />
          <Button
            type="primary"
            icon={<PlusOutlined />}
            className="bg-primary text-white"
          >
            Create New
          </Button>
        </div>

        <div className="flex  items-center gap-2">
          <Typography.Text>Show</Typography.Text>
          <Select
            defaultValue={10}
            onChange={(value) => setPageSize(value)}
            options={[10, 20, 30].map((size) => ({ value: size, label: size }))}
          />
          <Typography.Text>Entries</Typography.Text>
        </div>
      </div>
      <Table
        columns={columns}
        dataSource={data}
        scroll={{ x: 'max-content' }}
          pagination={{
          pageSize: pageSize,
          showSizeChanger: true,
          onShowSizeChange: (_, size) => setPageSize(size),
        }}
        className="bg-white rounded-lg border border-gray-200"
      />
    </div>
  );
};

export default Users;
